/**
 * External Links Registry
 *
 * All external endpoint URLs must be defined here — never inline strings in components or hooks.
 *
 * ## Naming convention
 * - Export name: `<domain>Endpoints` or `<domain>Requests` — match the closest existing name.
 * - Keys describe **consumer intent** (what the caller is doing), not the resource noun:
 *     ✅  search, report, download, create, update, delete, subscribe
 *     ❌  posts, users, bookings  (resource nouns — too ambiguous)
 *
 * ## Key patterns
 * - Static URL:           `contact: 'https://example.com/help-contact-us'`
 * - Dynamic URL:          `article: (slug: string) => \`https://example.com/resources/\${slug}\``
 * - Grouped sub-actions:  nest under `actions: { ... }` for secondary operations
 *                         (e.g. downloads, state transitions).
 *
 * ## Adding a new domain
 * 1. Add `export const <domain>Endpoints = Object.freeze({ ... })`.
 * 2. Store absolute external URLs (e.g. `https://...`) in this file.
 * 3. Use intent-based key names (see above).
 */

export const externalLinks = Object.freeze({
  contact: 'https://launch.secur.space/help-contact-us',
  faqs: 'https://launch.secur.space/securspace-faqs',
  gmsLanding: 'https://launch.secur.space/gmslanding',
  resourcesBuyer: 'https://launch.secur.space/buyer-resources',
  resourcesSupplier: 'https://launch.secur.space/supplier-resources',
});